import React from 'react'
import StandardProductDashboard from './StandardProductDashboard'
import {
  AttributedSentimentTile,
  CulturalRelevanceTile,
  EntityMetricTiles,
  RelevantSentimentTile,
  type KpiRow2Context,
} from './kpiTiles'

/**
 * Brand's row 2: CULTURAL RELEVANCE | RELEVANT SENTIMENT | ATTRIBUTED
 * SENTIMENT | MEANINGFUL ER. Brand leads with Cultural Relevance where the
 * other teams lead with Positive sentiment, and carries Meaningful ER alone.
 */
const brandKpiRow2 = (ctx: KpiRow2Context): React.ReactNode => (
  <>
    <CulturalRelevanceTile
      culturalRelevance={ctx.culturalRelevance}
      commentDateRange={ctx.commentDateRange}
    />
    <RelevantSentimentTile data={ctx.chartData['sentiment-relevant']} />
    <AttributedSentimentTile data={ctx.chartData['sentiment-attributed']} />
    <EntityMetricTiles keys={['meaningful_er_pct']} metrics={ctx.metrics} isLoading={ctx.metricsLoading} />
  </>
)

/**
 * Brand — Sky's brand dashboard.
 *
 * The highest-volume department by an order of magnitude (>=40,100 comments in 90 days), and the dashboard the other four were shown first.
 *
 * A department's dashboard is an ARRANGEMENT. Brand shares the standard grid
 * and differs only in row 2, which it states here through `kpiRow2`. When
 * Brand asks for more than that, this is the file that changes: drop
 * StandardProductDashboard, compose the kit primitives directly, and nothing
 * else in the codebase moves.
 */
export const BrandDashboard: React.FC = () => (
  <StandardProductDashboard
    product="brand"
    title="Brand"
    subtitle="Sky's masterbrand advertising and always-on social presence."
    kpiRow2={brandKpiRow2}
  />
)

export default BrandDashboard
